export const FLAGS = {
  SEASON_THREE: true,
  CULT: false,
} as const;
